import { useEffect, useState } from 'react';
import { keyValueStorage } from '@orionprotocol/common';

export function useIsAnalyticsEnabled(): boolean {
  const [isAnalyticsEnabledLS, setIsAnalyticsEnabledLS] = useState(
    keyValueStorage.getItem('analyticsEnabled'),
  );

  const setAnalyticsEnabled = (): void =>
    setIsAnalyticsEnabledLS(keyValueStorage.getItem('analyticsEnabled'));

  useEffect(() => {
    window.addEventListener('storage', setAnalyticsEnabled);

    return () => {
      window.removeEventListener('storage', setAnalyticsEnabled);
    };
  }, []);

  if (isAnalyticsEnabledLS === 'true') {
    return true;
  }

  if (isAnalyticsEnabledLS === 'false') {
    return false;
  }

  if (import.meta.env.VITE_ENV === 'production') {
    return true;
  }

  return false;
}
